import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { PersonalNestApi } from "../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { NestResponsesProvider } from "../../../shared/nestjs/nest-responses";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto } from "../../../shared/nestjs/gd-integrated/dto/reference.dto";
import { PsychologicaltestSf6Api } from "../../../shared/nestjs/gd-integrated/services/psychologicaltest-sf6.api";


@Injectable()
export class ProfilePsychologicalTestBloc {
  constructor(
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
    public nestResponse: NestResponsesProvider,		
    public psychologicaltestSf6Api: PsychologicaltestSf6Api
   ) {

   }

	add(data): Observable<ResponseAddDto> {
		return this.psychologicaltestSf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.psychologicaltestSf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.psychologicaltestSf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  listing(payload): Observable<any> {
		return this.psychologicaltestSf6Api.listing(payload.empId);
	}
}



// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-psychological-test.bloc.ts